import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {AntragTicketService} from "../../../@core/services/antrag-ticket/antrag-ticket.service";
import {faPlus, faSort} from '@fortawesome/free-solid-svg-icons';
import {TranslateService} from "@ngx-translate/core";
import {nullLastComparator} from "../../../@core/utils/forms/null-last-comparator";
import {catchError} from "rxjs/operators";
import {EMPTY} from "rxjs";
import {CustomToastService} from "../../../@core/utils/custom-toast.service";
import {CompositMessageService} from "../../../@core/services/compositMessage/compositMessage.service";
import {DatePipe} from "@angular/common";
import {AntragTicketMinimalDTO} from "../../../models/antrag-ticket/AntragTicketMinimalDTO";

@Component({
    selector: 'app-ticket-table',
    templateUrl: './ticket-table.component.html',
    styleUrls: ['./ticket-table.component.scss'],
    standalone: false
})
export class TicketTableComponent implements OnInit {

  faPlus = faPlus;
  sortInitial = faSort

  public columns: any;
  public rows: any;

  datePipe: DatePipe = new DatePipe("de-DE");

  isLoading = false;
  dataFetched = false;
  entityNameTranslationKey = 'TICKETANTRAG';

  @ViewChild("hdrTpl", {static: true}) hdrTpl: TemplateRef<any>;

  constructor(
    private router: Router,
    private antragTicketService: AntragTicketService,
    public translate: TranslateService,
    private customToastService: CustomToastService,
    private compositMessageService: CompositMessageService
  ) {
  }

  ngOnInit(): void {

    this.columns = [
      {name: 'name', headerTemplate: this.hdrTpl, comparator: nullLastComparator.bind(this)},
      {name: 'vorname', headerTemplate: this.hdrTpl, maxWidth: 150, comparator: nullLastComparator.bind(this)},
      {name: 'schule', headerTemplate: this.hdrTpl, prop: 'schuleName', comparator: nullLastComparator.bind(this)},
      {
        name: 'schuljahr',
        headerTemplate: this.hdrTpl,
        prop: 'schuljahrName',
        maxWidth: 120,
        comparator: nullLastComparator.bind(this)
      },
      {
        name: 'antragsdatum',
        headerTemplate: this.hdrTpl,
        maxWidth: 130,
        pipe: this.translateDatePipe(),
        comparator: nullLastComparator.bind(this)
      },
      {
        name: 'status',
        headerTemplate: this.hdrTpl,
        pipe: this.translatePipe(),
        comparator: nullLastComparator.bind(this)
      }
    ];

    this.isLoading = true;
    this.dataFetched = false;
    this.antragTicketService.getAllAntraegeMinimal()
      .pipe(
        catchError((err) => {
          this.customToastService.showError(this.compositMessageService.createErrorMessage(err, this.entityNameTranslationKey, 'getBulk'));
          this.isLoading = false;
          this.dataFetched = null;
          return EMPTY;
        })
      )
      .subscribe((data: AntragTicketMinimalDTO[]) => {
        this.rows = data;
        this.isLoading = false;
        this.dataFetched = this.rows.length > 0;
      });
  }

  onActivate(event) {
    if (event.type == 'click') {
      this.router.navigate(['/pages/ticket-detail/' + event.row.id]).catch(() => {
      });
    }
  }

  createNewEntwurf() {
    this.antragTicketService.createNewEntwurf()
      .subscribe({
        next: (value: number) => {
          if (value) {
            this.router.navigate(['/pages/ticket-detail/' + value])
              .then(() => {
                this.customToastService.showSuccess(this.translate.instant('ENTWURF.CREATE_SUCCESS'));
              }).catch(() => {
            })
          } else {
            this.customToastService.showError(this.translate.instant('ENTWURF.FAILURE'));
          }

        },

        error: (err) => {
          if (err.status === 422) {
            for (const entry of err.error) {
              if (entry.path?.includes('antragsteller')) {
                this.customToastService.showError(this.translate.instant('ENTWURF.CREATION_ERROR_PROFILE_FIELD_MISSING'));
                return;
              }
            }
            this.customToastService.showError(this.translate.instant('ENTWURF.FAILURE'));
          }
        }
      });

  }

  translatePipe() {
    return {transform: (value) => this.translate.instant('TICKET-TABLE.STATUS.' + value)};
  }

  translateDatePipe() {
    return {transform: (value) => this.datePipe.transform(value, 'dd.MM.yyyy')};
  }

  navigateToDetail(id: number) {
    this.router.navigate(['/pages/ticket-detail/' + id]).catch(() => {});
  }

  getStatusBadgeClass(status: string): string {
    const statusMap: { [key: string]: string } = {
      'ENTWURF': 'badge-dark',
      'EINGEREICHT': 'badge-warning',
      'IN_BEARBEITUNG': 'badge-warning',
      'GENEHMIGT': 'badge-success',
      'ABGELEHNT': 'badge-error',
      'ZURUECKGEZOGEN': 'badge-dark'
    };
    return statusMap[status] || 'badge-dark';
  }

}

